import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
import { purchaseAlerts } from '../data/content';
export function PurchaseAlert() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showTimeout = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(showTimeout);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimeout = window.setTimeout(() => setVisible(false), 6000);
    const nextTimeout = window.setTimeout(() => {
      setIndex(previous => (previous + 1) % purchaseAlerts.length);
      setVisible(true);
    }, 13000);
    return () => {
      window.clearTimeout(hideTimeout);
      window.clearTimeout(nextTimeout);
    };
  }, [visible, index, dismissed]);
  if (dismissed) return null;
  const alert = purchaseAlerts[index];
  return <AnimatePresence data-id="element-181" data-mp="2hpcptuzd0mn8">
      {visible && <motion.aside key={alert.name} initial={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} aria-live="polite" className="fixed bottom-5 left-4 z-50 flex max-w-[19rem] items-start gap-3 rounded-lg border border-gold/40 bg-night-card px-4 py-3 shadow-[0_18px_40px_-20px_rgba(0,0,0,0.9)]" data-id="element-182" data-mp="2ct5fzr3uer00">
          <CheckCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-183" data-mp="3age844ycmyaz" />
          <p className="min-w-0 text-xs leading-relaxed text-cream" data-id="element-184" data-mp="35grwfzy65q4a">
            <strong className="font-semibold" data-id="element-185" data-mp="1g23lm3588g8d">{alert.name}</strong> acaba de obtener la guía
            <span className="block text-cream-dim" data-id="element-186" data-mp="1g3y317hahq7p">
              {alert.location} · hace {2 + index} minutos
            </span>
          </p>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="-mr-1 -mt-1 shrink-0 rounded p-1 text-cream-dim transition-colors duration-150 ease-out hover:text-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-187" data-mp="20s7hadi47t9m">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-188" data-mp="2jqa2eh7jl625" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}